import { Link } from "react-router-dom";
export default function PrivacyPolicy() {
  window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <>
        <div className="page-head">
          <div className="container">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Privacy Policy</li>
            </ol>
            <h1>Privacy Policy</h1>
            <p className="text-mono" style={{ color: "#B9C0F0" }}>
              How we collect, use and protect your information.
            </p>
          </div>
        </div>
        <section className="section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-9">
                <p className="text-muted-soft">
                  Welcome to ‘’Learning 2 Earning Academy’’ We are committed to
                  protecting your privacy. This policy outlines how we collect,
                  use, disclose and safeguard personal information when you
                  visit our stock trading education website, based in , India.
                </p>
                <h4 className="mt-4">Information We Collect</h4>
                <p className="text-muted-soft">
                  <strong>Personal information:</strong> name, email, phone
                  number, address, and payment details when you register or
                  contact us.
                  <br />
                  <strong>Non-personal information:</strong> browser type, IP
                  address, device information and website usage data via cookies
                  and analytics.
                </p>
                <h4 className="mt-4">How We Use Your Information</h4>
                <p className="text-muted-soft">
                  To enhance website security, provide and improve our
                  educational services, process enrolments and payments, respond
                  to inquiries, and send opt-out-able promotional updates.
                </p>
                <h4 className="mt-4">Sharing Your Information</h4>
                <p className="text-muted-soft">
                  We do not sell or rent your personal data. We may share it
                  with payment processors and hosting providers who run our
                  website, with legal authorities if required by law, or with a
                  new entity in the event of a business transfer.
                </p>
                <h4 className="mt-4">Cookies &amp; Data Security</h4>
                <p className="text-muted-soft">
                  We use cookies to improve your browsing experience —
                  manageable via your browser settings. We take reasonable
                  security measures to protect your data, though no method of
                  transmission over the internet is 100% secure.
                </p>
                <h4 className="mt-4">Your Rights</h4>
                <p className="text-muted-soft">
                  Under Indian data protection law you may opt out of marketing
                  communications, access, correct or delete your personal
                  information, and withdraw consent for data processing where
                  applicable.
                </p>
                <h4 className="mt-4">Children's Privacy</h4>
                <p className="text-muted-soft">
                  Our services are generally intended for users 18 years or
                  older. Users under 18 may access our offerings only with
                  verifiable parental or guardian consent, and accounts for
                  minors are jointly managed with a parent/guardian, who may
                  review or request deletion of their child's data at any time.
                </p>
                <h4 className="mt-4">Contact Us</h4>
                <p className="text-muted-soft">
                  AMRIT PLAZA,JAMTARA ROAD,NIRSA,DHANBAD,JHARKHAND,828205
                </p>
                <p>+91 7004654910 </p>
                <p>
                  <a href="mailto:learning2earningsupport@gmail.com">
                    learning2earningsupport@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
}
